import { useMutation } from "@tanstack/react-query";
import api from "../../utils/api";
import { useInvalidateDomain } from "../../lib/invalidation";
import type { CostProfile, CostProfileInput } from "./types";

interface Envelope<T> {
  data?: { data?: T };
}

export function useCreateCostProfile() {
  const invalidateDomain = useInvalidateDomain();
  return useMutation({
    mutationFn: (input: Partial<CostProfileInput>): Promise<CostProfile> =>
      api.post<Envelope<CostProfile>>("/costProfiles", input).then((r) => r.data?.data?.data as CostProfile),
    onSuccess: () => invalidateDomain("costProfiles"),
  });
}

export function useUpdateCostProfile() {
  const invalidateDomain = useInvalidateDomain();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<CostProfileInput> }): Promise<CostProfile> =>
      api
        .put<Envelope<CostProfile>>("/costProfiles", data, { params: { id } })
        .then((r) => r.data?.data?.data as CostProfile),
    onSuccess: () => invalidateDomain("costProfiles"),
  });
}

export function useDeleteCostProfile() {
  const invalidateDomain = useInvalidateDomain();
  return useMutation({
    mutationFn: (id: string): Promise<void> => api.delete("/costProfiles", { params: { id } }).then(() => undefined),
    onSuccess: () => invalidateDomain("costProfiles"),
  });
}
